import { LpConfig, LpConfigForEnv } from './types';

export const UNLAUNCHED_LOCALES = ['ru'];

const configForPremiumCloseAccount: LpConfig = {
  siteId: '2422064',
  locales: {
    ar: 4435777550,
    nl: 4435774650,
    en: 4435714350,
    fr: 4435775650,
    de: 4435741350,
    id: 4435778550,
    it: 4435779950,
    ja: 4435181950,
    ko: 4435779050,
    pl: 4435780850,
    pt: 4435744950,
    es: 4435741850,
    sv: 4434982750,
    th: 4435782050,
    zh: 4435776850,
    tr: 4435782850,
    vi: 4435788350,
  },
};

const configForContactUs: LpConfigForEnv = {
  shared: {
    siteId: '88239568',
    locales: {
      de: 2415585650,
      en: 2138767350,
      es: 3011833050,
      fr: 2440717250,
      ja: 2440716250,
      pt: 3011901150,
      sv: 2440716550,
      nl: 2440716850,
      ar: 3410513550,
      zh: 3410878850,
      id: 3405078350,
      it: 3405171250,
      ko: 3410907150,
      pl: 3410978550,
      ru: 3410979450,
      th: 3410980050,
      tr: 3410883950,
      vi: 3410883050,
    },
  },
  prod: {
    siteId: '2422064',
    locales: {
      de: 2431177250,
      en: 2158598450,
      es: 2431230050,
      fr: 2431233750,
      ja: 2431232050,
      pt: 3012034150,
      sv: 2431232450,
      nl: 2431232950,
      ar: 3414209550,
      zh: 3413979950,
      id: 3414210650,
      it: 3414212150,
      ko: 3414211250,
      pl: 3414212950,
      ru: 3414234450,
      th: 3414236850,
      tr: 3414237950,
      vi: 3414260150,
    },
  },
};

const isTestFlagPresentInUrl = () => {
  const queryString = global.window?.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('lp_messaging_test') === 'true';
};

const isPremiumCloseAccountUrl = () => global.window?.location.pathname.includes('premium-close-account');

export const getCurrentConfig = (): LpConfig => {
  if (isPremiumCloseAccountUrl()) return configForPremiumCloseAccount;
  if (isTestFlagPresentInUrl()) return configForContactUs.shared;
  return process.env.NODE_ENV === 'production' ? configForContactUs.prod : configForContactUs.shared;
};
